/* global getChildElementIndex */
// **********************************************************
// Rating
// **********************************************************
const ratingStars = document.querySelectorAll('.rate-block__item-input');

ratingStars.forEach((el) => {
  el.addEventListener('change', (ev) => {
    const parentUl = ev.target.closest('ul');
    const parentAllLi = parentUl.querySelectorAll('li');
    const clickedElemParent = ev.target.closest('li');
    const clickedElemIndex = getChildElementIndex(clickedElemParent);

    parentAllLi.forEach((elm, i) => {
      const starInput = elm.querySelector('.rate-block__item-input');
      starInput.checked = i <= clickedElemIndex;
    });
  });
});
